var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-controls" }, [
    _c("div", { staticClass: "c-slidecontrols" }, [
      _c(
        "button",
        {
          staticClass: "c-slidecontrols__prev",
          attrs: { disabled: _vm.prevDisabled },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.prev.apply(null, arguments)
            }
          }
        },
        [
          _c("svg", { staticClass: "icon icon_vorige" }, [
            _c("use", { attrs: { "xlink:href": "#icon_vorige" } })
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "button button--control",
          attrs: { disabled: _vm.nextDisabled },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.next.apply(null, arguments)
            }
          }
        },
        [
          _vm._v("\n\t\t\tVolgende slide "),
          _c("svg", { staticClass: "icon icon_next" }, [
            _c("use", { attrs: { "xlink:href": "#icon_next" } })
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }